import React from "react";

const BulkDiscountsTable = ({ tiers }) => {
    return (
        <div>
            <h4 className="offerHeading"><i className="fas fa-tag"></i>Class set offer</h4>
            <table className="classSetCarouselTable" cellSpacing="0" style={{maxWidth: 'unset'}}>
                <thead>
                    <tr>
                        <th>Qty</th>
                        <th>Save</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody>
                    {tiers.map((tier, i) => (
                        <tr key={i}>
                            <td>{tier.to ? `${tier.from}-${tier.to}` : `${tier.from}+`}</td>
                            <td>{tier.discount}%</td>
                            <td>£{Number(tier.price).toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default BulkDiscountsTable;
